module.exports = __webpack_public_path__ + "static/media/up-arrow.23d3b5fc.png";